import { LOCALES } from "../locales";

import home from "./fr-CA/home";
import countries from "./fr-CA/countries";
import titles from "./fr-CA/titles";
import warnings from "./fr-CA/warnings";
import errors from "./fr-CA/errors";
import misc from "./fr-CA/misc";
import accountCreation from "./fr-CA/accountCreation";
import payment from "./fr-CA/payment";
import footer from "./fr-CA/footer";

export default{
    [LOCALES.FRENCH] : {
        ...home,
        ...countries,
        ...titles,
        ...warnings,
        ...errors,
        ...misc,
        ...accountCreation,
        ...payment,
        ...footer,
    },
}